<template>
  <div class="columns is-mobile">
    <div class="column dashboard__menu">
      <div class="sidebar sidebar--static">
        <div class="inner">
          <ul class="sidebar-menu">
            <li title="Quản lý phòng họp">
              <router-link
                :to="'/ongoing-conference-list'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-conf_control.png" alt="Quản lý phòng họp">
                <span class="is-block polycom-link-text">Quản lý phòng họp</span>
              </router-link>
            </li>
            <li title="Quản lý người dùng">
              <router-link
                :to="'/user-management'"
                class="polycom-link is-active">
                <img src="@/assets/images/icons/icon-address.png" alt="Quản lý người dùng">
                <span class="is-block polycom-link-text">Quản lý người dùng</span>
              </router-link>
            </li>
            <li title="Tạo lịch họp">
              <router-link
                :to="'/calendar'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-schedule.png" alt="Tạo lịch họp">
                <span class="is-block polycom-link-text">Tạo lịch họp</span>
              </router-link>
            </li>
            <li title="Lọc người tham gia phòng họp">
              <router-link
                :to="'/passcode-room-management'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-reservation.png" alt="Lọc người tham gia phòng họp">
                <span class="is-block polycom-link-text">Lọc người tham gia phòng họp</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="column content-management">
      <div class="breadcrumb-wrapper">
        <img src="@/assets/images/icons/icon-home.png" alt="" class="icon-home">
        <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
          <ul>
            <li><router-link to="/index">Trang chủ</router-link></li>
            <li class="is-active"><a>Quản lý người dùng</a></li>
          </ul>
        </nav>
      </div>
      <div class="userlist__heading is-clearfix">
        <div class="content-wrapper is-pulled-left">
          <div class="field has-addons field-search-party is-horizontal">
            <div class="field-label">
              <label class="label label--filter-party">Lọc tài khoản</label>
            </div>
            <div class="control custom-control">
              <form @submit.prevent="searchPartiesUI">
                <b-input
                  type="search"
                  icon="search"
                  v-model="keywordPartyName"
                  autocomplete="on"
                />
              </form>
            </div>
          </div>
        </div>
        <div class="is-pulled-right right-control">
          <div class="field is-grouped">
            <div class="control">
              <a
                @click="showModalAddUser = true"
                class="add-user-block">
                <b-icon
                  icon="plus-circle"
                  size="is-medium"
                  pack="fas"
                  class="add-user-block__icon color-primary-2"/>
                <span class="color-primary-2 txt-add">Thêm người dùng mới</span>
              </a>
            </div>
            <div class="control">
              | <a @click="isDeleteMultiUserModal = true,selectedUser = null">
                <span class="has-text-danger txt-add">Xoá nhiều</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal"
        :class="`${showModalAddUser ? 'is-active' : ''}`"
        id="modal-bis">
        <div class="modal-background" @click="showModalAddUser = false"></div>
        <div class="modal-content">
          <div class="modal-content__add">
            <user-add
              :currentUser="currentUser"
              @hide-modal="showModalAddUser = $event" :is-parent-show-add-user="showModalAddUser"/>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="showModalAddUser = false"/>
      </div>
      <div class="columns">
        <div class="userlist column">
          <div class="field is-grouped userlist__button" v-if="selectedUser">
            <div class="control">
              <b-button type="is-info" @click="setUserStatus">{{getUserStatusText}}</b-button>
            </div>
            <div class="control">
              <b-button type="is-danger" @click="isDeleteUserModal=true">Xoá 1 người dùng</b-button>
            </div>
            <div class="control">
              <b-button type="is-info" @click="openUpdatePassModal">Thay đổi mật khẩu</b-button>
            </div>
          </div>
          <div class="user-list-count">
            <div class="has-text-weight-bold">Có {{totalOrderedUser}} / {{userList&&userList.length}} người dùng</div>
          </div>
          <div class="user-list-key">
            <div
              class="user-link"
              :class="{'checked': list.key === computedSelectedAlphabet}"
              v-for="list in orderedUserList" :key="list.key"
              @click="scrollElement(list.key)">
              <div>{{list.key}}</div>
            </div>
          </div>
          <div class="columns is-gapless colums--no-margin">
            <div class="column is-one-fourth has-text-weight-semibold order">STT</div>
            <div class="column is-one-fourth has-text-weight-semibold account">Tài khoản</div>
            <div class="column is-one-fourth has-text-weight-semibold">Tên</div>
            <div class="column is-one-fourth has-text-weight-semibold">Email</div>
          </div>
          <div v-if="!totalOrderedUser" class="has-text-centered mt-40">Không có kết quả</div>
          <div
            v-if="userList&&orderedUserList"
            class="userlist__wrapper"
            ref="orderList">
            <div
              class="user-list-row"
              v-for="(list, index) in orderedUserList"
              :key="list.key">
              <div
                class="user-alphabet has-text-weight-semibold"
                :ref="list.key">{{list.key}}
              </div>
              <div
                class="columns is-vcentered is-gapless colums--no-margin"
                v-for="(user, subIndex) in list.value"
                :key="user.name"
                :class="{'bg-grey': user.disabled === 'true'}">
                  <div class="column is-one-fourth order">{{subIndex+orderedUserList[index].total+1}}</div>
                  <div class="column is-one-fourth">
                    <b-radio
                      v-model="selectedUser"
                      :native-value="user"
                      type="is-info"
                      class="color-primary-2"/>
                    <span
                      class="icon-user-book"
                      v-if="user.disabled === 'false'">
                      <img src="@/assets/images/icons/icon-user.png" alt="">
                    </span>
                    <span class="icon-user-book" v-else>
                      <img src="@/assets/images/icons/icon-user_disabled.png" alt="">
                    </span>
                    <span class="userlist__username">{{user.name}}</span>
                  </div>
                  <div class="column is-one-fourth"><span class="middle-text">{{user.firstName}}</span></div>
                  <div class="column is-one-fourth"><span class="middle-text">{{user.email}}</span></div>
              </div>
            </div>
          </div>
          <b-modal :active.sync="isOpenUpdatePassModal">
            <div class="content-layout content-layout--passcode">
              <header class="modal-card-head">
                <p class="modal-card-title">Thay đổi mật khẩu {{this.selectedUser && this.selectedUser.name}}</p>
                <button
                  aria-label="close"
                  class="delete"
                  @click="isOpenUpdatePassModal=false"/>
              </header>
              <form @submit.prevent="validatePassword">
              <div class="content-layout__inner">
                <div class="form-user">
                  <b-field
                    :type="{'is-danger': errors.has('password')}"
                    :message="errors.first('password')"
                    custom-class="has-text-weight-normal body-text"
                  >
                    <template slot="label">
                      Mật khẩu <span class="has-text-danger">*</span>
                    </template>
                    <b-input
                      v-model="password"
                      type="password"
                      name="password"
                      v-validate="{required: true, regex: /\w/, min: 8}"
                      size="is-medium"
                      ref="updatePassword"
                      data-vv-as="Mật khẩu"
                    />
                  </b-field>

                  <b-field
                    :type="{'is-danger': errors.has('confirm-password')}"
                    :message="errors.first('confirm-password')"
                    custom-class="has-text-weight-normal body-text"
                  >
                    <template slot="label">
                      Xác nhận mật khẩu <span class="has-text-danger">*</span>
                    </template>
                    <b-input
                      v-model="confirmPassword"
                      v-validate="{ required: true, is: password }"
                      type="password"
                      name="confirm-password"
                      size="is-medium"
                      data-vv-as="Xác nhận mật khẩu"
                    />
                  </b-field>
                </div>
              </div>
              <div class="modal-bottom-group field is-grouped is-grouped-centered">
                <div class="control">
                  <b-button @click="isOpenUpdatePassModal=false">Đóng</b-button>
                </div>
                <div class="control">
                  <b-button type="is-info" native-type="submit">Thay đổi</b-button>
                </div>
              </div>
              </form>
            </div>
          </b-modal>
          <b-modal :active.sync="isDeleteUserModal">
            <div class="content-layout content-layout--passcode">
              <header class="modal-card-head">
                <p class="modal-card-title">Xoá participant {{this.selectedUser && this.selectedUser.name}}</p>
                <button
                  aria-label="close"
                  class="delete"
                  @click="isDeleteUserModal=false"/>
              </header>
              <div class="content-layout__inner">
                <div class="body-text">Xin xác nhận xoá participant?</div>
              </div>
              <div class="modal-bottom-group field is-grouped is-grouped-centered">
                <div class="control">
                  <b-button @click="isDeleteUserModal=false">Đóng</b-button>
                </div>
                <div class="control">
                  <b-button type="is-danger" @click="deleteUser">Xoá</b-button>
                </div>
              </div>
            </div>
          </b-modal>
          <b-modal :active.sync="isDeleteMultiUserModal">
            <div class="content-layout">
              <header class="modal-card-head">
                <p class="modal-card-title">Chọn nhiều để xoá participant</p>
                <button
                  aria-label="close"
                  class="delete"
                  @click="isDeleteMultiUserModal=false"/>
              </header>
              <div class="content-layout__inner">
                <div class="field has-addons field-search-party is-horizontal">
                  <div class="field-label column is-one-third vvc-field-label__search__model">
                    <label class="label label--delete-party">Lọc tên người dùng</label>
                  </div>
                  <div class="control custom-control">
                    <b-input
                      type="search"
                      icon="search"
                      v-model="keywordRemovableParticipant"
                      autocomplete="on"
                    />
                  </div>
                </div>
                <div class="vvc-party-count">
                  Participant {{selectedParticipants&&selectedParticipants.length}}
                </div>
                <b-field
                  :type="{'is-danger': errors.has('removableUser.users')}"
                  :message="errors.first('removableUser.users')"
                  custom-class="has-text-weight-normal">
                  <div class="table userList__table">
                    <div
                      class="username__wrapper"
                      @click="selectAllParties"
                      v-if="computedSelectedParticipants.length">
                      <input
                        type="checkbox"
                        class="username__input"
                        :checked="getAllCheckedParties"> <span class="username__text">Tất cả</span>
                    </div>
                    <div class="userList__table__limit">
                      <div
                        v-for="(user) in lastSelectedParticipants"
                        :key="user.name"
                        @click="selectParty(user)"
                      >
                        <div class="username__wrapper">
                          <input
                            type="checkbox"
                            class="username__input"
                            :checked="user.checked"
                            data-vv-scope="removableUser"
                            name="users"
                            v-validate ="'required'"
                            data-vv-as="participant"> <span class="username__text">{{user.name}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-field>
              </div>
              <div class="modal-bottom-group field is-grouped is-grouped-centered">
                <div class="control">
                  <b-button @click="isDeleteMultiUserModal=false">Đóng</b-button>
                </div>
                <div class="control">
                  <b-button
                    type="is-danger"
                    :disabled="!computedSelectedParticipants.length"
                    @click="openConfirmDeleteMultiParty">Chọn xoá</b-button>
                </div>
              </div>
            </div>
          </b-modal>
          <b-modal :active.sync="isConfirmDeleteMultiUserModal">
            <div class="content-layout">
              <header class="modal-card-head">
                <p class="modal-card-title">Xác nhận xoá nhiều participant</p>
                <button
                  aria-label="close"
                  class="delete"
                  @click="isConfirmDeleteMultiUserModal=false"/>
              </header>
              <div class="content-layout__inner">
                <div class="body-text">Xin xác nhận xoá nhiều participant?</div>
              </div>
              <div class="modal-bottom-group field is-grouped is-grouped-centered">
                <div class="control">
                  <b-button @click="isConfirmDeleteMultiUserModal=false">Đóng</b-button>
                </div>
                <div class="control">
                  <b-button type="is-danger" @click="deleteMultiUser">Xoá</b-button>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
        <div class="column" v-if="userListByAdmin&&userListByAdmin.length">
          <div class="user-list-count">
            <div class="has-text-weight-bold">Có {{userListByAdmin&&userListByAdmin.length}} người dùng từ admin</div>
          </div>
          <div class="user-list-key">
            <div
              class="user-link"
              :class="{'checked': list.key === computedSelectedAlphabetByAdmin}"
              v-for="list in orderedUserListByAdmin"
              :key="list.key"
              @click="scrollElementByAdmin(list.key)">
              <div>{{list.key}}</div>
            </div>
          </div>
          <div class="columns is-gapless colums--no-margin">
            <div class="column is-one-fourth has-text-weight-semibold order">STT</div>
            <div class="column is-one-fourth has-text-weight-semibold account">Tài khoản</div>
            <div class="column is-one-fourth has-text-weight-semibold">Tên</div>
            <div class="column is-one-fourth has-text-weight-semibold">Email</div>
          </div>
          <div
            v-if="userListByAdmin&&orderedUserListByAdmin"
            class="userlist__wrapper"
            ref="orderListByAdmin">
            <div
              class="user-list-row"
              v-for="(list, index) in orderedUserListByAdmin"
              :key="list.key">
              <div
                class="user-alphabet has-text-weight-semibold"
                :ref="`partyAdmin${list.key}`">{{list.key}}
              </div>
              <div
                class="columns is-vcentered is-gapless colums--no-margin"
                v-for="(user, subIndex) in list.value"
                :key="user.name"
                :class="{
                  'bg-grey': user.disabled === 'true',
                  'bg-odd': ((index+subIndex+1)%2)}"
                >
                  <div class="column is-one-fourth order">{{subIndex+orderedUserListByAdmin[index].total+1}}</div>
                  <div class="column is-one-fourth">
                    <span
                      class="icon-user-book"
                      v-if="user.disabled === 'false'">
                      <img src="@/assets/images/icons/icon-user.png" alt="">
                    </span>
                    <span class="icon-user-book" v-else>
                      <img src="@/assets/images/icons/icon-user_disabled.png" alt="">
                    </span>
                    <span class="userlist__username">{{user.name}}</span>
                  </div>
                  <div class="column is-one-fourth">
                    <span class="middle-text">{{user.firstName}}</span>
                  </div>
                  <div class="column is-one-fourth">
                    <span class="middle-text">{{user.email}}</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from '../shared/Utils'
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    UserAdd: () => import("./UserAdd")
  },
  mounted() {
    this.getParticipants(this.$store.state.auth.entityTag);
    this.getParticipantsByAdmin()
  },
  data() {
    return {
      selectedUser: null,
      isOpenUpdatePassModal: false,
      password: "",
      confirmPassword: "",
      showModalAddUser: false,
      selectedAlphabet: null,
      keywordPartyName: '',
      isDeleteUserModal: false,
      isDeleteMultiUserModal: false,
      selectedParticipants: [],
      isConfirmDeleteMultiUserModal: false,
      keywordRemovableParticipant: '',
      lastSelectedParticipants: [],
      selectedAlphabetByAdmin: null
    };
  },
  methods: {
    setUserStatus() {
      const user = { ...this.selectedUser };
      user.disabled = user.disabled.toLowerCase() === "true" ? "false" : "true";
      this.disableParticipant(user).then(() => {
        const newSelectedUSer = this.userList.find(
          user => user.name === this.selectedUser.name
        );
        this.selectedUser = newSelectedUSer;
      });
    },
    deleteUser() {
      const { name } = this.selectedUser;
      let owner;
      owner = this.$store.state.auth.username;

      this.deleteParticipant({name,owner}).then(res => {
        
        let message = "";
        if (res.data.status) {
          message = "Xoá người dùng thành công!";
          this.selectedUser = null;
        } else {
          message = "Lỗi máy chủ!!";
        }
        this.$toast.open({
          message,
          type: "is-info"
        });
      }).finally(() => {
        this.isDeleteUserModal = false
      });
    },
    validatePassword() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updatePassWord();
        }
      });
    },
    updatePassWord() {
      const password = this.password;
      const user = { ...this.selectedUser, password };
      this.changePassword(user).then(() => {
        let message = "Thay đổi mật khẩu thành công!";
        this.isOpenUpdatePassModal = false;
        this.$toast.open({
          message,
          type: "is-info"
        });
      });
    },
    ...mapActions("participant", [
      "getParticipants",
      "disableParticipant",
      "deleteParticipant",
      "changePassword",
      "deleteMultiParticipants",
      "getParticipantsByAdmin",
      "searchParties"
    ]),
    ...mapMutations("participant", [
      "resetUserList"
    ]),
    scrollElement(evt) {
      if(this.orderedUserList.length) {
        const firstEleTop = this.$refs[this.orderedUserList[0].key][0].offsetTop
        this.selectedAlphabet = evt
        this.$refs.orderList.scrollTop = this.$refs[evt][0].offsetTop - firstEleTop
      }
    },
    updatePartyList(list) {
      let result = list.reduce((accumulator, current) => {
        const index = accumulator.findIndex(item => {
          return item.key.toUpperCase() === current.name.split('')[0].toUpperCase()
        })
        if(index === -1) {
          accumulator.push({key: current.name.split('')[0].toUpperCase(), value: []})
          accumulator[accumulator.length-1]['value'].push(current)
        } else {
          accumulator[index]['value'].push(current)
        }
        return accumulator
      }, []).sort((userList1, userList2) => {
        return userList1.key < userList2.key ? -1 : 1
      })

      let count = 0

      result = result.map((obj, index) => {
        const newObj = {...obj}
        if(index===0) {
          newObj.total = 0
        } else if(index > 0) {
          count+= result[index-1].value.length
          newObj.total = count
        }
        return newObj
      })
      return result
    },
    openUpdatePassModal() {
      this.isOpenUpdatePassModal = true
      this.$nextTick(() => {
        this.$refs.updatePassword.$el.querySelector('input').focus()
      })
    },
    selectParty(data) {
      this.lastSelectedParticipants = [...this.lastSelectedParticipants.map(user => {
        if(user.name === data.name) {
          user.checked = !user.checked
        }
        return user
      })]
    },
    selectAllParties() {
      if(this.getAllCheckedParties) {
        this.lastSelectedParticipants = [...this.lastSelectedParticipants.map(user => {
          user.checked = false
          return user
        })]
      } else {
        this.lastSelectedParticipants = [...this.lastSelectedParticipants.map(user => {
          user.checked = true
          return user
        })]
      }
    },
    openConfirmDeleteMultiParty() {
      this.$validator.validateAll('removableUser').then(result => {
        if(result) {
          this.isConfirmDeleteMultiUserModal = true
        }
      })
    },
    deleteMultiUser() {
      const participants = this.lastSelectedParticipants.filter(user => user.checked).map(user => {
        return {name: user.name}
      })
      this.deleteMultiParticipants({owner: this.$store.state.auth.username, participants}).then((res) => {
          if(res.data.status) {
            this.$toast.open({
              message: res.data.message,
              type: "is-info"
            });
          } else {
            this.$toast.open({
              message: res.data.message,
              type: "is-info"
            });
          }
        }).finally(() => {
          this.isDeleteMultiUserModal = false
          this.isConfirmDeleteMultiUserModal = false
        })
    },
    searchPartiesUI() {
      this.searchParties(Utils.latinify(this.keywordPartyName))
    }
  },
  computed: {
    ...mapState("participant", ["userList", "userListByAdmin"]),
    getUserStatusText() {
      return this.selectedUser.disabled === "true"
        ? "Kích hoạt người dùng"
        : "Vô hiệu hoá người dùng";
    },
    currentUser() {
      return this.$store.state.auth.username
    },
    orderedUserList() {
      let result = []
      if(this.userList) {
        result = this.updatePartyList(this.userList)
      }
      return result
    },
    orderedUserListByAdmin() {
      let result = []
      if(this.userListByAdmin) {
        result = this.updatePartyList(this.userListByAdmin)
      }
      return result
    },
    totalOrderedUser() {
      let total=0;
      if(this.orderedUserList.length) {
        total = this.orderedUserList.reduce((cumm, curr) => {
          cumm += curr.value.length
          return cumm
        }, 0)||0
      }
      return total
    },
    computedSelectedAlphabet() {
      if(this.selectedAlphabet) {
        return this.selectedAlphabet
      }
      return this.orderedUserList[0].key
    },
    getAllCheckedParties() {
      return this.lastSelectedParticipants.every(user => user.checked) && this.lastSelectedParticipants.length
    },
    computedSelectedParticipants() {
      if(!this.keywordRemovableParticipant.length) return this.selectedParticipants
      return this.selectedParticipants.filter(party => {
        return party.name.toLowerCase().includes(this.keywordRemovableParticipant)
      })
    },
  },
  watch: {
    userList() {
      if(this.userList) {
        this.selectedParticipants = [...this.userList.map(user => {
          const data = user
          data.checked = false
          return data
        }).sort((user1, user2) => {
          return user1.name < user2.name ? -1 : 1
        })]
      }
    },
    selectedParticipants() {
      this.lastSelectedParticipants = [...this.selectedParticipants]
    },
    keywordRemovableParticipant() {
      if(!this.keywordRemovableParticipant.length) {
        this.lastSelectedParticipants = [...this.selectedParticipants]
        return
      }
      this.lastSelectedParticipants = [...this.selectedParticipants.filter(party => {
        return party.name.toLowerCase().includes(this.keywordRemovableParticipant)
      })]
    }
  }
};
</script>

<style lang="scss">
.userlist__button {
  margin-left: 15px;
}
.userlist {
  &__icon {
    vertical-align: text-top;
    margin-right: 1rem;
  }
  &__table {
    overflow-x: scroll;
  }
}
.add-user-block {
  margin-left: 30px;
  &:hover {
    opacity: .8;
  }
  display: flex;
  span {
    svg {
      width: 3rem;
      height: 3rem;
    }
  }
}
.txt-add {
  font-size: 1.2rem;
  margin-left: 10px;
}

.modal-content__add {
  padding: 1rem;
}
.modal-close {
  height: 64px !important;
  max-height: 64px !important;
  max-width: 64px !important;
  min-height: 64px !important;
  min-width: 64px !important;
  width: 64px !important;
}
.radio-button {
  width: 30px;
}
.icon-user-book {
  display: inline-block;
  width: 30px;
  vertical-align: middle;
  margin-right: 15px;
}
.userlist__table {
  &.table td {
    vertical-align: middle;
    border: 0;
  }
}
.radio {
  vertical-align: middle;
}
.middle-text {
  display: inline-block;
  vertical-align: middle;
}
.columns.is-gapless > .column:first-child {
  padding-left: 15px!important;
  &.account {
    padding-left: 25px!important;
  }
}
.user-alphabet {
  padding: 10px 90px;
  background-color: #f8f8f8;
}
.columns {
  padding: 5px 0;
}
.userlist__wrapper {
  max-height: 300px;
  overflow-y: auto;
}
.user-list-key,
.user-list-count {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 30px;
}
.user-link {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #14afb4;

  &.checked {
    background-color: #14afb4;
    border-radius: 50%;
    color: #fff;
  }
}
.field-search-party .input {
  width: 270px;
  height: 32px;
}

.columns.is-gapless:not(:last-child) {
  &.colums--no-margin {
    margin-bottom: 0;
  }
}
.userlist__heading {
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #dbdbdb;
}
.field-label {
  .label--filter-party {
    font-size: 1.2rem;
    font-weight: 400;
  }
}
.order {
  flex: 0 0 90px;
}
.right-control {
  margin-right: 30px;
}
.vvc-field-label__search__model {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.label--delete-party {
  font-size: 14px;
  color: inherit;
  font-weight: 400;
}
.vvc-party-count {
  padding: 0 10px;
}
</style>